import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function FileNotifFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.75 10.8022C20.75 10.8013 20.75 10.8032 20.75 10.8022V10.8022Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.25 5.92698L3.25 5.75C3.25 4.23122 4.48122 3 6 3H6.16717C4.55735 3 3.25244 4.31034 3.25 5.92698ZM6.19144 24.5C4.58211 24.5 3.27678 23.1903 3.27427 21.573L3.25 5.92698L3.25 21.75C3.25 23.2688 4.48122 24.5 6 24.5H6.19144ZM17.8328 24.5H18C19.5188 24.5 20.75 23.2688 20.75 21.75V21.5732C20.7474 23.1901 19.4423 24.5 17.8328 24.5ZM20.75 10.8022V10.75C20.75 10.6235 20.718 10.5003 20.6585 10.3911C20.7178 10.5187 20.7496 10.6588 20.75 10.8022ZM13.2189 3.03267C13.1382 3.01116 13.0544 3 12.9695 3H13C13.0749 3 13.1486 3.0112 13.2189 3.03267Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.6585 10.3911C20.7178 10.5187 20.7496 10.6588 20.75 10.8022V10.75C20.75 10.6235 20.718 10.5003 20.6585 10.3911ZM13.2189 3.03267C13.1382 3.01116 13.0544 3 12.9695 3H13C13.0749 3 13.1486 3.0112 13.2189 3.03267Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.16717 3C4.55735 3 3.25244 4.31034 3.25 5.92698C3.25 4.30825 4.55584 3 6.16717 3Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.75 10.8022V11.5V21.5732C20.7474 23.1901 19.4423 24.5 17.8328 24.5H6.19144C4.58211 24.5 3.27678 23.1903 3.27427 21.573L3.25 5.92698C3.25244 4.31034 4.55735 3 6.16717 3H12.25H12.9695C13.0544 3 13.1382 3.01116 13.2189 3.03267C13.3354 3.06825 13.4426 3.13201 13.5303 3.21973L13.75 3.43945V5.56055V6.14205V8.75C13.75 9.44036 14.3096 10 15 10H17.5968H18.1895H20.3105L20.5303 10.2197C20.5815 10.2709 20.6245 10.3287 20.6585 10.3911C20.7178 10.5187 20.7496 10.6588 20.75 10.8022ZM7.25391 19.75C7.25391 20.1642 7.58969 20.5 8.00391 20.5H16.0039C16.4181 20.5 16.7539 20.1642 16.7539 19.75C16.7539 19.5569 16.6809 19.3808 16.561 19.2478C16.4237 19.0957 16.225 19 16.0039 19H8.00391C7.78074 19 7.58033 19.0975 7.44294 19.2522C7.32534 19.3846 7.25391 19.559 7.25391 19.75ZM7.25391 15.75C7.25391 16.1642 7.58969 16.5 8.00391 16.5H12.0039C12.4181 16.5 12.7539 16.1642 12.7539 15.75C12.7539 15.5569 12.6809 15.3808 12.561 15.2478C12.4237 15.0957 12.225 15 12.0039 15H8.00391C7.78074 15 7.58033 15.0975 7.44294 15.2522C7.32534 15.3846 7.25391 15.559 7.25391 15.75Z"
				fill="currentColor"
			/>
			<circle cx="18.75" cy="5" r="4" fill="#1E72BD" stroke="white" strokeWidth="2" />
		</svg>
	);
}

FileNotifFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default FileNotifFilledIcon;
